<template>
  <div>
    <div id="content" class="login h-100" style="margin-top: -75px">
      <!-- Main Content -->
      <div class="main-content h-100" style="margin-top: 50px">
        <div class="row h-100">
          <!-- Client -->
          <div class="col-12">
            <div class="card">
              <div class="card-header h-50">
                <img
                  class="icon-login"
                  src="../assets/images/icon-green.png"
                  alt="Icon"
                />
                <img
                  class="logo-login"
                  src="../assets/images/logo-green.png"
                  alt="Logo"
                />
              </div>
              <div class="card-body login-title">
                <div class="row" style="margin-top: 100px">
                  <div class="col-12">
                    <div class="title">
                      <i class="fas fa-sign-in-alt"></i>Login
                      <span>Bem-vindo(a)!</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <form>
                  <div class="form-group">
                    <label for="inputEmail1">E-mail</label>
                    <input
                      class="form-control"
                      type="email"
                      id="user"
                      v-model="email"
                      placeholder
                      required
                      autocomplete="off"
                    />
                  </div>
                  <div class="form-group mb-2">
                    <label for="inputPassword1">Senha</label>
                    <input
                      class="form-control"
                      type="password"
                      id="password"
                      v-model="password"
                      placeholder
                      required
                    />
                  </div>
                  <div class="custom-control custom-checkbox float-left">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="remindCheck"
                    />
                    <label class="custom-control-label" for="remindCheck"
                      >Lembrar-me</label
                    >
                  </div>
                  <a href class="forgot float-right">Esqueci minha senha</a>
                </form>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-main mb-0" @click="login">
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      new_path: "/",
      email: "",
      password: "",
      forgot: {
        email: "",
      },
    };
  },
  computed: {},
  methods: {
    reveal() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push({ path: this.new_path });
        })
        .catch((error) => {
          self.$message("Erro", "Credenciais incorretas", "error");
        });
    },

    forgotPassword() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  components: {},
  props: {},
  mounted: function () {
    const self = this;

    var url = self.$route.fullPath.split("?url=%2F");
    if (url[1]) {
      self.new_path = url[1];
    }
  },
};
</script>
<style scoped>
input {
  color: black;
}

label {
  margin-bottom: -3px;
  margin-top: 3px;
}

.login a {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue